// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1IjQ9","title":"ClientReferral_title__1xcRJ","itemText":"ClientReferral_itemText__3WMSk"};